import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { BonusesSection } from '../components/BonusesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-brand-primary selection:text-slate-900" data-id="element-266">
      <HeroSection data-id="element-267" />
      <ProblemSection data-id="element-268" />
      <SolutionSection data-id="element-269" />
      <ProtocolSection data-id="element-270" />
      <BonusesSection data-id="element-271" />
      <TestimonialsSection data-id="element-272" />
      <FAQSection data-id="element-273" />
      <CTASection data-id="element-274" />
      <Footer data-id="element-275" />
    </div>;
}